import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['searchInput', 'addUsersButton'];

  static outlets = ['components--admin-data-table'];

  static values = {
    qualificationId: String,
    confirmAllow: String,
    confirmCancel: String,
    confirmTitle: String,
    confirmMessage: String
  }

  connect() {
    this._boundSyncAddUsersButton = this._syncAddUsersButton.bind(this);
    document.addEventListener('promote:data-table:selection', this._boundSyncAddUsersButton);
  }

  disconnect() {
    document.removeEventListener('promote:data-table:selection', this._boundSyncAddUsersButton);
  }

  _syncAddUsersButton() {
    this.addUsersButtonTarget.disabled = this._selectedUserIds().length === 0;
  }

  openForm() {
    if (this.ajaxRequest) {
      this.ajaxRequest.abort();
    }

    const params = new URLSearchParams();
    this._selectedUserIds().forEach(id => params.append('user_ids[]', id));

    const url = `/admin/qualifications/${this.qualificationIdValue}/user_qualification_users/new?${params.toString()}`;

    this.load(url);
  }

  newUserForm(event) {
    if (this.ajaxRequest) {
      this.ajaxRequest.abort();
    }

    let searchInput = this.element.querySelector('input[name="search"]');

    const params = new URLSearchParams();
    if (searchInput) {
      params.set('search', searchInput.value);
    }

    const url = `/admin/qualifications/${this.qualificationIdValue}/user_qualification_users/new?${params.toString()}`;

    this._handleSelection(event, url);
  }

  cancel(event) {
    if (this.ajaxRequest) {
      this.ajaxRequest.abort();
    }

    const url = `/admin/qualifications/${this.qualificationIdValue}/edit?tab=user_qualifications`;

    this._handleSelection(event, url);
  }

  _handleSelection(event, url) {
    const requiresConfirmation = this._selectedUserIds().length > 0;

    if (requiresConfirmation) {
      const confirmed = Rails.confirm(null, event.target, this._confirmationModalDataset());

      if (!confirmed) {
        return;
      }
    }

    this.load(url);
  }

  _confirmationModalDataset() {
    return {
      confirmError: true,
      confirmCancel: this.confirmCancelValue,
      confirmAllow: this.confirmAllowValue,
      confirmMessage: this.confirmMessageValue,
      confirmTitle: this.confirmTitleValue
    };
  }

  _selectedUserIds() {
    if (!this.hasComponentsAdminDataTableOutlet) return [];

    return [...this.componentsAdminDataTableOutlet.state.selectedItems.values()]
      .map((entry) => entry.id);
  }

  load(url) {
    Rails.ajax({
      url: url,
      type: 'GET',
      dataType: 'script',
      beforeSend: (xhr) => {
        this.ajaxRequest = xhr;
        return true;
      }
    });
  }
}
